const support = {
    maintenanceEmail: "hello@shopdm.store",
    maintenancePhone: "+17676128202",
    operationsPhone: "+17676120435",
    partnersPhone: "+17672453052",
    companyAddress: {
        line1: "Top Floor, 20 Bath Road",
        city: "Roseau",
        country: "Dominica",
    }
}

export const getFullCompanyAddress = () => `${support.companyAddress.line1}, ${support.companyAddress.city}, ${support.companyAddress.country}`

export default support